// Dependencies
import React from 'react';
import propTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Styles
import TimelineStyles from './timeline.styles';

export default function Timeline({ layout }) {
  const bgImg = layout?.backgroundImage;

  const heading = layout?.heading;
  const subheading = layout?.subheading;
  const events = layout?.events;

  return (
    <TimelineStyles>
      <Image image={bgImg} backgroundColor="sand" background />

      <Container>
        {heading && <h2 className="heading large">{heading}</h2>}
        {subheading && <h2 className="subheading">{subheading}</h2>}
      </Container>
      <Container>
        {events?.length && (
          <div className="events">
            {events.map((event) => (
              <div className="event" key={uuid()}>
                <div className="block">
                  <h6 className="date">{event?.date}</h6>
                  <p>{event?.text}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </TimelineStyles>
  );
}

Timeline.propTypes = {
  layout: propTypes.shape({
    backgroundImage: propTypes.shape({
      altText: propTypes.string,
      gatsbyImage: propTypes.shape({}),
    }),
    heading: propTypes.string,
    subheading: propTypes.string,
    events: propTypes.arrayOf(
      propTypes.shape({
        date: propTypes.string,
        text: propTypes.string,
      }),
    ),
  }),
};

Timeline.defaultProps = {
  layout: {},
};
